module.exports = __webpack_public_path__ + "img/product_51.a782361.svg";